<script lang="ts">
    import CN from "classnames";

    export let view: "row" | "col" = "row";
</script>

<hr
    class={CN("gw-separator gw-default-reset", `gw-separator-${view}`)}
    aria-orientation={view === "col" ? "vertical" : undefined}
/>

<style>
    .gw-separator {
        width: 100%;
        border: none;
    }

    .gw-separator-row {
        border-top: 1px solid var(--gw-divider-border-color);
    }

    .gw-separator-col {
        border-left: 1px solid var(--gw-divider-border-color);
    }
</style>
